import React from "react";
import { Plus, LifeBuoy } from "lucide-react";
import PageHeader, { PrimaryButton, PageKPIItem } from "components/ui/PageHeader";

interface SupportHeaderProps {
    kpiData: {
        label: string;
        value: string | number;
        icon: any;
        color: string;
        bgColor?: string;
        change?: string;
        changeValue?: number;
        isPositive?: boolean;
    }[];
    isLoading?: boolean;
    onNewTicket?: () => void;
}

const SupportHeader: React.FC<SupportHeaderProps> = ({
    kpiData,
    isLoading = false,
    onNewTicket,
}) => {
    /* Map kpiData → PageKPIItem shape */
    const accentPalette = [
        { accentColor: "bg-gradient-to-r from-blue-500 to-indigo-500", accentHex: "#6366f1", iconBg: "bg-blue-50 dark:bg-blue-900/20", iconColor: "text-blue-600 dark:text-blue-400" },
        { accentColor: "bg-gradient-to-r from-emerald-400 to-teal-500", accentHex: "#10b981", iconBg: "bg-emerald-50 dark:bg-emerald-900/20", iconColor: "text-emerald-600 dark:text-emerald-400" },
        { accentColor: "bg-gradient-to-r from-amber-400 to-orange-500", accentHex: "#f59e0b", iconBg: "bg-amber-50 dark:bg-amber-900/20", iconColor: "text-amber-600 dark:text-amber-400" },
        { accentColor: "bg-gradient-to-r from-violet-500 to-purple-500", accentHex: "#8b5cf6", iconBg: "bg-violet-50 dark:bg-violet-900/20", iconColor: "text-violet-600 dark:text-violet-400" },
    ];

    const kpis: PageKPIItem[] = kpiData.map((stat, i) => ({
        icon: stat.icon,
        value: stat.value,
        label: stat.label,
        ...accentPalette[i % accentPalette.length],
    }));

    return (
        <PageHeader
            icon={<LifeBuoy className="w-5 h-5" />}
            iconBg="bg-blue-50 dark:bg-blue-900/20"
            iconColor="text-blue-600 dark:text-blue-400"
            accentColor="bg-gradient-to-r from-blue-500 to-indigo-500"
            title="Support Dashboard"
            subtitle="Manage customer support tickets and requests"
            actions={
                onNewTicket ? (
                    <PrimaryButton icon={<Plus className="w-4 h-4" />} onClick={onNewTicket}>
                        New Ticket
                    </PrimaryButton>
                ) : undefined
            }
            kpis={kpis}
            isLoading={isLoading}
        />
    );
};

export default SupportHeader;
